<template>
  <q-icon
    v-if="isCircuitLevel || isSiteLevel"
    :name="isCircuitLevel ? 'business' : 'store'"
    size="sm"
    class="q-ml-sm"
  >
    <q-tooltip>
      {{ isCircuitLevel ? 'Circuit' : 'Site' }} Level
    </q-tooltip>
  </q-icon>
</template>

<script>
import { MODEL_LEVEL } from 'src/models/model'

export default {
  name: 'ModelLevelIcon',
  configuration: ['currentCircuit'],
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  computed: {
    isCircuitLevel () {
      return this.currentCircuit.sites.data.length > 1 && this.model.level === MODEL_LEVEL.CIRCUIT
    },
    isSiteLevel () {
      return this.currentCircuit.sites.data.length > 1 && this.model.level === MODEL_LEVEL.SITE
    }
  }
}
</script>
